import { OktaAuthnErrorCodes } from './okta-auth-api.consts';

export const getOktaErrorMessage = (oktaErrorObj: { errorCode?: string }, isPasswordOnlyFlow?: boolean): string => {
  switch ((oktaErrorObj || {}).errorCode) {
    case OktaAuthnErrorCodes.AuthenticationFailed:
      return isPasswordOnlyFlow ? 'Password is incorrect, please try again.' : 'Email or password are incorrect, please try again.';
    case OktaAuthnErrorCodes.AccessDenied:
      return 'The email entered has no access to this application.';
    default:
      return 'Oops, something went wrong, please try again later.';
  }
};
